export default "__VITE_ASSET__D87BdXxv__"